import React, { useContext, useEffect, useState } from 'react';
import './Forgetpass.css';
import '../../component/layouts/Style.css';


import Helmet from '../../component/Helmet/Helmet';

import { Container, Row, Col } from 'reactstrap';

import Sidebar from '../../component/layouts/Sidebar';
import MobileTopBar from '../../component/layouts/MobileTopBar';
import RightSide from '../../component/layouts/rightSide';
import { AppContext } from '../../context/AppContext';
import { useLocation, useNavigate } from 'react-router-dom';




const Restpass = () => {

 const {token, setToken} = useContext(AppContext);

    const [formData, setFormData] = useState({
            email:'',
            password:'',
            password_confirmation:''
            
    })

      const location = useLocation();

      const navigate = useNavigate()

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const emailFromUrl = params.get('email');
    if (emailFromUrl) {
      setFormData(prev => ({ ...prev, email: emailFromUrl }));
    }
  }, [location]);

    const [errors, setErrors] = useState({}); 
    const [serverMessage, setServerMessage] = useState('');

  const handleChanges = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrors({});
    try {
      const response = await fetch('https://dashboard.tiktaka.com/api/restPassword', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(formData)
      });
      const data = await response.json();
      setServerMessage(data.message);


      if (response.ok) {
        alert("✅ تم التسجيل بنجاح!");
        console.log(data);
        
        localStorage.setItem('token', data.token);
        setToken(data.token);
        navigate('/');

      } else if (response.status === 422) {
        setErrors(data.errors);
      }
    } catch (error) {
      alert('⚠️ حصل خطأ في الاتصال بالسيرفر');
    }
  };




  return (
  <Helmet title='Forget Password'>
    <div className="Forgetpass">
   
    <Sidebar/>

    <div className='midSide'>
    <div className='middleSideHome'>
    
    <MobileTopBar/>
      
      {/* Start Main Section */}

        <div className='mainSection'>
            <section>
                <Container>
                    <Row>
                        <Col lg='6' md='6' sm='12' className='loginBox'>

                            {/* <Col lg='6' md='6' sm='12' className='loginBox'> */}
                        <form onSubmit={handleSubmit} className='material-form'>
                            <div className='input-field'>
                                <input type='text'  name='email' value={formData.email} readOnly ></input>
                                <label style={{ top: '-1.2rem', fontSize: '0.8rem',color: '#2196F3' }}>Email</label>
                                <span className="bar"></span>
                              
                            </div>

                        <div className='input-field'>
                            <input type='password' placeholder='password' name='password'  value={formData.password}
                                    onChange={handleChanges} ></input>
                            <label>Password</label>
                            <span className="bar"></span>
                            {errors.password && (
                                    <div style={{ color: "red", fontSize: "12px" }}>
                                    {errors.password[0]}
                                    </div>
                            )}
                        </div>

                        <div className='input-field'>
                            <input type='password' placeholder='password_confirmation' name='password_confirmation'  value={formData.password_confirmation}
                                    onChange={handleChanges} ></input>
                            <label>Password Confirmation</label>
                            <span className="bar"></span>
                            {errors.password_confirmation && (
                                    <div style={{ color: "red", fontSize: "12px" }}>
                                    {errors.password_confirmation[0]}
                                    </div>
                            )}
                        </div>


                            <button type='submit'>Submit</button>
                        </form>
                        </Col>
                    </Row>
                </Container>
           </section>
        </div>
     {/* End Main Section  */}
    </div>
    </div>
   
   <RightSide/>

  </div>
  </Helmet>
  );
};

export default Restpass;